export default "__VITE_ASSET__BAEAQge$__"